// import React, { useState } from "react";
// import { Container, Row, Col, Accordion, Button } from "react-bootstrap";
// import {
//   FaMoon,
//   FaUtensils,
//   FaWhatsapp,
//   FaPrint,
//   FaEnvelope,
//   FaSearch,
//   FaAngleDown,
//   FaAngleUp,
// } from "react-icons/fa";
// import "./../../assets/css/ItinerarySection.css";

// const ItinerarySection = ({packages}) => {
//   const [allCollapsed, setAllCollapsed] = useState(true);

//   const toggleAllDays = () => {
//     setAllCollapsed(!allCollapsed);
//   };

//   // Itinerary data
//   const itineraryData = [
//     {
//       day: "Day 1 / 16 May, 25",
//       location: "Srinagar (4 Nights)",
//       content: [
//         'Schedule your flight departure to <span class="highlight">Srinagar</span>. Upon arrival, our Radhe Shyam World Tour Manager will guide you through airport formalities and lead you into the city.',
//         "Joining and Leaving (J&L) guests will join the group on their own at the first destination as per the information provided.",
//         "Book your air tickets to align with the scheduled tour flight for seamless airport transfers with the group.",
//         "Early arrivals or departures will require self-arranged transfers to the designated place or hotel.",
//         "In the evening, enjoy a short Meet & Greet session.",
//         '<span class="highlight">Dress Colour for today:</span> Yellow',
//       ],
//       accommodation: "Night Stay in Srinagar",
//       meals: "Dinner",
//     },
//     {
//       day: "Day 2 / 17 May, 25",
//       location: "Srinagar - Pahalgam - Srinagar",
//       content: [
//         "Embark on a scenic drive to <span class=\"highlight\">Pahalgam</span>, known as the 'Valley of Shepherds'.",
//         "Explore the Betaab Valley, named after the Bollywood movie shot here, and enjoy the serene Lidder River.",
//         "Optional pony rides to the Aru Valley (at your own cost) for breathtaking views.",
//         "Return to Srinagar by evening for a relaxing night.",
//       ],
//       accommodation: "Night Stay in Srinagar",
//       meals: "Breakfast, Lunch, Dinner",
//     },
//     {
//       day: "Day 3 / 18 May, 25",
//       location: "Srinagar - Gulmarg - Srinagar",
//       content: [
//         'Head to <span class="highlight">Gulmarg</span>, a paradise for nature lovers and adventure seekers.',
//         "Enjoy the Gondola ride (at your own cost) to witness panoramic views of snow-capped peaks.",
//         "Try skiing or snowboarding if weather permits (equipment rental extra).",
//         "Return to Srinagar for a cozy evening.",
//       ],
//       accommodation: "Night Stay in Srinagar",
//       meals: "Breakfast, Dinner",
//     },
//     {
//       day: "Day 4 / 19 May, 25",
//       location: "Srinagar",
//       content: [
//         'Explore the enchanting city of <span class="highlight">Srinagar</span>.',
//         "Visit the Mughal Gardens, including Shalimar Bagh and Nishat Bagh, known for their stunning architecture and fountains.",
//         "Enjoy a peaceful Shikara ride on Dal Lake, surrounded by floating gardens.",
//         "Evening free to explore local markets for souvenirs like Pashmina shawls.",
//       ],
//       accommodation: "Night Stay in Srinagar",
//       meals: "Breakfast, Dinner",
//     },
//     {
//       day: "Day 5 / 20 May, 25",
//       location: "Srinagar - Departure",
//       content: [
//         'After breakfast, check out from the hotel in <span class="highlight">Srinagar</span>.',
//         "Transfer to the airport for your departure flight.",
//         "Carry back memories of the stunning landscapes and warm hospitality of Kashmir.",
//         "We wish you a safe journey home!",
//       ],
//       accommodation: "",
//       meals: "Breakfast",
//     },
//   ];

//   console.log("asdsad")
//   const transformedPackages = packages?.tour_plans?.map((item, index) => ({
//   day: `Day ${index + 1}`,
//   location: item.route?.[0]?.name || 'Location not specified',
//   content: item.details ? [item.details] : [],
//   accommodation: item.overnight || '',
//   meals: item.meals || '',
// }));

//   return (
//     <section className="itinerary-section">
//       <Container>
//         <Row>
//           {/* Itinerary List */}
//           <Col md={8}>
//             <div className="d-flex justify-content-between align-items-center mb-4">
//               <h2 className="itinerary-header">Itinerary (Day Wise)</h2>
//               <Button
//                 variant="link"
//                 className="toggle-days"
//                 onClick={toggleAllDays}
//               >
//                 {allCollapsed ? "Show all days" : "Hide all days"}
//               </Button>
//             </div>

//             <div className="itinerary-timeline">
//               {transformedPackages?.map((item, index) => (
//                 <div className="itinerary-item" key={index}>
//                   <span className="marker"></span>
//                   <Accordion
//                     defaultActiveKey={allCollapsed ? "" : `${index}`}
//                     className="day-accordion"
//                   >
//                     <Accordion.Item eventKey={`${index}`} className="border-0">
//                       <Accordion.Header>
//                         <div className="day-header">
//                           <div className="day">{item.day}</div>
//                           <div className="location">{item.location}</div>
//                         </div>
//                       </Accordion.Header>
//                       <Accordion.Body>
//                         {item.content.map((paragraph, pIndex) => (
//                           <p
//                             key={pIndex}
//                             dangerouslySetInnerHTML={{ __html: paragraph }}
//                           ></p>
//                         ))}

//                         {item.accommodation && (
//                           <div className="itinerary-icon-box">
//                             <FaMoon className="icon" />
//                             <span>{item.accommodation}</span>
//                           </div>
//                         )}

//                         <div className="itinerary-icon-box">
//                           <FaUtensils className="icon" />
//                           <span>{item.meals}</span>
//                         </div>
//                       </Accordion.Body>
//                     </Accordion.Item>
//                   </Accordion>
//                 </div>
//               ))}
//             </div>
//           </Col>

//           {/* Map and Actions */}
//           <Col md={4}>
//             <div className="map-container">
//               <div className="map-placeholder">
//                 <div className="map-overlay">
//                   <div className="map-error">
//                     <div className="map-error-icon">!</div>
//                     <div className="map-error-title">Map loading...</div>
//                     <div className="map-error-message">
//                       Interactive map will be displayed here
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <Button className="map-view-btn">Map View</Button>
//             </div>

//             <div className="distance-link">
//               <a href="#">Click here to find the road distance</a>
//             </div>

//             <div className="action-buttons">
//               <Button className="btn-action btn-whatsapp">
//                 <FaWhatsapp />
//                 <span>Send</span>
//               </Button>
//               <Button className="btn-action btn-print">
//                 <FaPrint />
//                 <span>Print</span>
//               </Button>
//               <Button className="btn-action btn-email">
//                 <FaEnvelope />
//                 <span>Email</span>
//               </Button>
//               <Button className="btn-action btn-compare">
//                 <FaSearch />
//                 <span>Compare</span>
//               </Button>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default ItinerarySection;


import React, { useMemo, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Accordion,
  Button,
  Modal,
  Carousel,
} from "react-bootstrap";

import { FaMoon, FaUtensils, FaChevronLeft, FaChevronRight, FaBus } from "react-icons/fa";

import "./../../assets/css/ItinerarySection.css";
import BASE_URL from "../../component/commanfile";

const ItinerarySection = ({ packages }) => {
  const [activeKey, setActiveKey] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [expandAll, setExpandAll] = useState(false);

  const [previewVehicleIdx, setPreviewVehicleIdx] = useState(0);
  const [previewRateId, setPreviewRateId] = useState(null);

  // -----------------------------
  // DATA TRANSFORMATION
  // -----------------------------
  const transformedPackages = useMemo(() => {
    return packages?.itinerary?.map((item, index) => ({
      day: item.day || `Day ${index + 1}`,
      title: item.title || "",
      description: item.description || "",
      activities: item.activities || [],
      accommodation: item.accommodation || "",
      meals: Array.isArray(item.meals) ? item.meals : [],
      images: item.images || [],
    })) || [];
  }, [packages]);

  const allVehicles = useMemo(() => {
    return packages?.busDetails || [];
  }, [packages]);

  const selectedVehicle =
    allVehicles?.[previewVehicleIdx] || allVehicles?.[0] || null;

  // -----------------------------
  // VEHICLE IMAGE HELPERS
  // -----------------------------
  const getVehicleImages = (vehicle) => {
    if (!vehicle) return [];

    const imgs = vehicle?.vehicleImage;

    if (Array.isArray(imgs)) return imgs.filter(Boolean);
    if (typeof imgs === "string") return [imgs];

    return [];
  };

  const vehicleImages = useMemo(() => {
    return getVehicleImages(selectedVehicle);
  }, [selectedVehicle]);

  const imageChunks = useMemo(() => {
    const chunks = [];
    for (let i = 0; i < vehicleImages.length; i += 3) {
      chunks.push(vehicleImages.slice(i, i + 3));
    }
    return chunks;
  }, [vehicleImages]);

  // -----------------------------
  // EFFECTS
  // -----------------------------
  useEffect(() => {
    if (previewVehicleIdx >= allVehicles.length) {
      setPreviewVehicleIdx(0);
    }
  }, [allVehicles, previewVehicleIdx]);

  // -----------------------------
  // HANDLERS
  // -----------------------------
  const handleAccordionToggle = (key) => {
    setActiveKey((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  const openModal = (place) => setModalData(place);
  const closeModal = () => setModalData(null);

  // -----------------------------
  // RENDER SAFETY
  // -----------------------------
  if (!packages) return null;

  return (
    <section className="itinerary-section pt-0">
      <Container>
        <Row>
          {/* ---------------- VEHICLES SECTION ---------------- */}
          <Col lg={12}>
            <div className="modern-fit-selector mt-4">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h4 className="mb-0 Tour-title" style={{ color: "#0a3b78" }}>
                    Our Vehicles
                  </h4>
                  <div className="text-muted small">
                    Swipe to see more interior & exterior views
                  </div>
                </div>

                <div className="text-end">
                  <span className="badge rounded-pill bg-light text-primary border border-primary px-3 py-2">
                    {selectedVehicle?.vehicleName || "No Vehicle"}
                  </span>
                </div>
              </div>

              {/* Vehicle Tabs */}
              <div className="d-flex gap-2 mb-4 overflow-auto pb-2 ">
                {allVehicles.map((veh, index) => (
                  <button
                    key={veh.id || index}
                    onClick={() => {
                      setPreviewVehicleIdx(index);
                      setPreviewRateId(
                        veh?.seatConfigurationRate?.[0]?.id || null
                      );
                    }}
                    className={`tab-minimal ${
                      previewVehicleIdx === index ? "active" : ""
                    }`}
                  >
                    {veh.vehicleName || veh.vihicalname}
                  </button>
                ))}
              </div>

              {/* Carousel */}
              <div className="carousel-container-modern">
                {vehicleImages.length > 0 ? (
                  <Carousel
                    indicators
                    interval={4000}
                    className="custom-carousel"
                    prevIcon={<FaChevronLeft className="nav-icon" />}
                    nextIcon={<FaChevronRight className="nav-icon" />}
                  >
                    {imageChunks.map((chunk, chunkIdx) => (
                      <Carousel.Item key={chunkIdx}>
                        <Row className="gx-3 px-1">
                          {chunk.map((img, imgIdx) => (
                            <Col xs={4} key={imgIdx}>
                              <div className="img-card-premium">
                                <img
                            src={`${BASE_URL}/api/image?file=${img}`}
                            alt="Vehicle view"
                            onError={(e) => (e.target.src = "https://via.placeholder.com/400x300?text=View")}
                                />
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <div className="no-photo-box">
                    <FaBus size={40} className="mb-2 opacity-25" />
                    <p className="mb-0">Images under update</p>
                  </div>
                )}

                {/* Floating Info */}
                <div className="floating-info-card shadow-lg">
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color: "#0a3b78" }}>
                        {selectedVehicle?.vehicleName ||
                          selectedVehicle?.vihicalname}
                      </h6>
                      <small className="text-muted">
                        {selectedVehicle?.totalSeats} Seats
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ---------------- STYLE ---------------- */}
            <style dangerouslySetInnerHTML={{ __html: `
              .no-scrollbar::-webkit-scrollbar { display: none; }

              .tab-minimal {
                padding: 8px 18px;
                border-radius: 10px;
                border: 1px solid #eef2f6;
                background: #fff;
                color: #7f8c8d;
                font-weight: 500;
                font-size: 14px;
                white-space: nowrap;
              }

              .tab-minimal.active {
                background: #0a3b78;
                color: #fff;
              }

              .carousel-container-modern {
                position: relative;
                padding-bottom: 50px;
              }

              .img-card-premium {
                height: 180px;
                border-radius: 16px;
                overflow: hidden;
              }

              .img-card-premium img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              .floating-info-card {
                position: absolute;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
                background: rgba(255,255,255,0.95);
                padding: 15px 30px;
                border-radius: 20px;
                min-width: 320px;
              }

              .nav-icon {
                background: #fff;
                padding: 10px;
                border-radius: 50%;
                box-shadow: 0 4px 15px rgba(0,0,0,0.1);
              }

              .no-photo-box {
                height: 200px;
                background: #f8fafc;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 20px;
              }

              @media (max-width: 768px) {
                .img-card-premium { height: 100px; }
                .floating-info-card { min-width: 90%; }
              }
            `}} />
          </Col>

          {/* ---------------- ITINERARY SECTION ---------------- */}
          <Col md={12} className="mt-4">

            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="itinerary-header">Itinerary (Day Wise)</h2>

              <Button
                variant="outline-primary"
                onClick={() => {
                  if (expandAll) {
                    setActiveKey([]);
                  } else {
                    setActiveKey(
                      transformedPackages.map((_, idx) => String(idx))
                    );
                  }
                  setExpandAll(!expandAll);
                }}
              >
                {expandAll ? "Hide All" : "Show All"}
              </Button>
            </div>

            <Accordion activeKey={activeKey} alwaysOpen>

              {transformedPackages.map((item, index) => (
                <Accordion.Item
                  eventKey={String(index)}
                  key={index}
                  className="modern-day-card shadow-sm mb-3"
                >
                  <Accordion.Header
                    onClick={() => handleAccordionToggle(String(index))}
                  >
                    <div className="w-100 d-flex align-items-center">
                      <h5 className="mb-0">Day {item.day}</h5>
                      <small className="text-muted px-3" style={{ fontSize: "18px" }}>
                        {item.title}
                      </small>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <p>{item.description}</p>

                    <h6 className="fw-bold">Activities Covered:</h6>
                    {item.activities.map((place, i) => (
                      <div key={i} className="p-2 mb-2 shadow-sm rounded">
                        - {place}
                      </div>
                    ))}

                    {item.accommodation && (
                      <div className="mt-3">
                        <FaMoon /> {item.accommodation}
                      </div>
                    )}

                    {item.meals.length > 0 && (
                      <div className="mt-2">
                        <FaUtensils /> {item.meals.join(", ")}
                      </div>
                    )}
                  </Accordion.Body>

                </Accordion.Item>
              ))}

            </Accordion>
          </Col>
        </Row>
      </Container>

      {/* ---------------- MODAL ---------------- */}
      <Modal show={!!modalData} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalData?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>No extra detail available.</p>
        </Modal.Body>
      </Modal>

    </section>
  );
};

export default ItinerarySection;